module.exports = __webpack_public_path__ + "img/white_queen.ac545044.png";